import { RightOutlined } from '@ant-design/icons/lib'
import { List as AntList, Row } from 'antd'
import { ListProps } from 'antd/lib/list'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'

interface Props extends ListProps<IDeliveryItem> {
  deliveryItems: IDeliveryItem[]
}

const List: React.FC<Props> = ({ deliveryItems, ...others }) => {
  return (
    <AntList
      rowKey="id"
      itemLayout="vertical"
      dataSource={deliveryItems}
      renderItem={(item: IDeliveryItem, index: number) => (
        <AntList.Item key={index}>
          <AntList.Item.Meta
            className="mb-0"
            title={
              <span className="text-black">
                {item.name} {item.delivery_date}
              </span>
            }
          />
          <If condition={item.cargos.length}>
            <Row>
              <KCol span={24}>
                <AntList
                  size="small"
                  dataSource={item.cargos}
                  renderItem={(cargo) => (
                    <span className="d-block my-1">
                      <RightOutlined className="mr-1" />
                      {cargo.name}
                    </span>
                  )}
                />
              </KCol>
            </Row>
          </If>
        </AntList.Item>
      )}
      {...others}
    />
  )
}

export default List
